import React from 'react';
import PropTypes from 'prop-types';
import Button from '@/components/button';
import styles from './footer.module.scss';
import { CDN_BASE_URL } from '@/constants';

const Footer = (props) => (
  <div className={styles.container}>
    <div className={styles.leftButton} onClick={props.onCancel}>取消</div>
    <img className={styles.rightButton} src={`${CDN_BASE_URL}/send03.svg`} onClick={props.onSend} />
  </div>
);

Footer.propTypes = {
  onSend: PropTypes.func,
  onCancel: PropTypes.func,
};

export default Footer;
